import React, {useContext} from 'react';
import clsx from 'clsx';
import Select, {components, DropdownIndicatorProps, ClearIndicatorProps, MultiValueRemoveProps} from 'react-select';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import {MultiSelect} from 'react-multi-select-component';
import {useTranslation} from 'react-i18next';
import {Context} from '../../../Helpers/Auth';
import "./App.css"
function MultiSelectComponent({value, options, onChange, onInputChange, noOptionsMessage, placeholder, isDisabled}) {
    const sortedOptions = Array.isArray(options) ? options.slice().sort((a, b) => a.label.localeCompare(b.label)) : [];
    const {t} = useTranslation();
    const {theme} = useContext(Context);
    return (
        // <ReactSelect
        //   isMulti
        //   value={value}
        //   options={sortedOptions}
        //   onChange={onChange}
        //   noOptionsMessage={noOptionsMessage}
        //   placeholder={placeholder}
        //   onInputChange={onInputChange}
        //   isDisabled={isDisabled}
        // />
        <div className="mt-2 w-36 w">
            <MultiSelect
                isDisabled={isDisabled}
                className={theme == 'dark' ? 'dark' : ''}
                options={sortedOptions}
                value={value}
                onChange={onChange}
                overrideStrings={{
                    selectSomeItems: t('filtro'),
                    allItemsAreSelected: t('todosItens'),
                    selectAll: t('selecionarTudo'),
                    search: t('pesquisar'),
                    clearSearch: t('limparPesquisa'),
                }}
                noOptionsMessage={() => t('semopcoes')}
                onInputChange={onInputChange}
            />
        </div>
    );
}

export default MultiSelectComponent;
